// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Space+Grotesk:wght@500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * NO-Q Design Tokens
 * Single source of truth for colors, radii, shadows, and fonts.
 * Copy this file into another project and import it once at the app entry
 * (e.g. in index.css / globals.css or main.tsx):  import "./theme/noq-theme.css";
 *
 * Pair it with tailwind-preset.js so Tailwind utilities (bg-primary,
 * text-txt-main, rounded-noq-md, etc.) resolve to these variables.
 */

:root {
  /* Brand / actions */
  --action-primary: #cef24e;
  --action-primary-hover: #B8D945;
  --text-link: #3B82F6;

  /* Surfaces */
  --surface-background-light: #F0F2F5;
  --surface-background-dark: #121212;
  --neutral-white: #FFFFFF;
  --borders-dividers: #E5E7EB;
  --border-color: var(--borders-dividers);

  /* Status */
  --error: #EF4444;
  --success: #10B981;

  /* Text */
  --text-primary-light: #121212;
  --text-secondary-light: #6B7280;
  --text-primary-dark: #F0F2F5;
  --text-secondary-dark: #6B7280;

  /* Radii */
  --radius-sm: 8px;
  --radius-md: 16px;
  --radius-lg: 24px;
  --radius-full: 9999px;

  /* Elevation */
  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);

  /* Typography */
  --font-sans: 'Space Grotesk', sans-serif;

  /* Theme-aware aliases */
  --background: var(--surface-background-light);
  --text: var(--text-primary-light);
}

/* Dark mode override — toggled by adding the \`dark\` class to <html> or <body> */
.dark {
  --background: var(--surface-background-dark);
  --text: var(--text-primary-dark);
}
`, "",{"version":3,"sources":["webpack://./src/theme/noq-theme.css"],"names":[],"mappings":"AAAA;;;;;;;;EAQE;;AAIF;EACE,oBAAoB;EACpB,yBAAyB;EACzB,+BAA+B;EAC/B,oBAAoB;;EAEpB,aAAa;EACb,mCAAmC;EACnC,kCAAkC;EAClC,wBAAwB;EACxB,2BAA2B;EAC3B,uCAAuC;;EAEvC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;;EAElB,SAAS;EACT,6BAA6B;EAC7B,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;;EAE9B,UAAU;EACV,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;;EAErB,cAAc;EACd,0CAA0C;;EAE1C,eAAe;EACf,wCAAwC;;EAExC,wBAAwB;EACxB,6CAA6C;EAC7C,iCAAiC;AACnC;;AAEA,gFAAgF;AAChF;EACE,4CAA4C;EAC5C,gCAAgC;AAClC","sourcesContent":["/*\n * NO-Q Design Tokens\n * Single source of truth for colors, radii, shadows, and fonts.\n * Copy this file into another project and import it once at the app entry\n * (e.g. in index.css / globals.css or main.tsx):  import \"./theme/noq-theme.css\";\n *\n * Pair it with tailwind-preset.js so Tailwind utilities (bg-primary,\n * text-txt-main, rounded-noq-md, etc.) resolve to these variables.\n */\n\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&family=Space+Grotesk:wght@500;700&display=swap');\n\n:root {\n  /* Brand / actions */\n  --action-primary: #cef24e;\n  --action-primary-hover: #B8D945;\n  --text-link: #3B82F6;\n\n  /* Surfaces */\n  --surface-background-light: #F0F2F5;\n  --surface-background-dark: #121212;\n  --neutral-white: #FFFFFF;\n  --borders-dividers: #E5E7EB;\n  --border-color: var(--borders-dividers);\n\n  /* Status */\n  --error: #EF4444;\n  --success: #10B981;\n\n  /* Text */\n  --text-primary-light: #121212;\n  --text-secondary-light: #6B7280;\n  --text-primary-dark: #F0F2F5;\n  --text-secondary-dark: #6B7280;\n\n  /* Radii */\n  --radius-sm: 8px;\n  --radius-md: 16px;\n  --radius-lg: 24px;\n  --radius-full: 9999px;\n\n  /* Elevation */\n  --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);\n\n  /* Typography */\n  --font-sans: 'Space Grotesk', sans-serif;\n\n  /* Theme-aware aliases */\n  --background: var(--surface-background-light);\n  --text: var(--text-primary-light);\n}\n\n/* Dark mode override — toggled by adding the `dark` class to <html> or <body> */\n.dark {\n  --background: var(--surface-background-dark);\n  --text: var(--text-primary-dark);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
